import { CloseOutlined } from '@mui/icons-material';
import { Box, IconButton, Toolbar, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type UtilityDrawerTitleType = {
  title: string | React.ReactNode;
  subtitle: string | React.ReactNode;
  onClose: ((e: any) => void) | undefined;
};

const UtilityDrawerTitle = ({
  title,
  subtitle,
  onClose,
}: UtilityDrawerTitleType) => {
  const { t } = useTranslation();

  return (
    <>
      <Toolbar sx={{ mb: 2, pt: 2 }}>
        <Typography
          variant="h1"
          sx={{ flexGrow: 1 }}
          data-testid="UtilityDrawer.Typography.Title"
        >
          {title}
        </Typography>

        {/*
          An icon on its own has no accessible name, so every drawer in the portal
          had a close button screen readers could only announce as "button".
        */}
        <IconButton
          onClick={onClose}
          aria-label={t('forms.buttons.close')}
          data-testid="UtilityDrawer.IconButton.Close"
        >
          <CloseOutlined />
        </IconButton>
      </Toolbar>
      <Box px={[2, 3]}>
        {typeof subtitle === 'string' ? (
          <Typography
            variant="body1"
            fontWeight="bold"
            data-testid="UtilityDrawer.Typography.Subtitle"
          >
            {subtitle}
          </Typography>
        ) : (
          subtitle
        )}
      </Box>
    </>
  );
};

export default UtilityDrawerTitle;
